
// Zenyth Custom video transcriptions
// Transcriptions attached to the product video section
// Using metafields from the product page
$(document).ready(function () {
  if ($(".znt-custom-disclosure").length) {
    $(".znt-custom-disclosure").click(function () {
      var expanded = $(this).attr("aria-expanded");
      if (expanded === "true") {
        $(this).attr("aria-expanded", "false");
      } else {
        $(this).attr("aria-expanded", "true");
      }
    });
  }
});



// Filter - Search results refactor
$(document).ready(function () {
  if ($(".znt-filter-wrapper").length) {
    // Trigger
    $("#znt-filter-btn_01").click(function () {
      var expanded = $(this).attr("aria-expanded");
      if (expanded === "true") {
        $(this).attr("aria-expanded", "false");
      } else {
        $(this).attr("aria-expanded", "true");
        setTimeout(function () {
          $("#znt-filter-btn-close_01").focus();
        }, 200);

        // Traps focus in the second level
        var $filterSubmenu = $(".znt-filter-panel");

        $filterSubmenu.on("keydown", function (e) {
          if (e.keyCode === 9) {
            // Tab key
            var $filterFocusable = $filterSubmenu
              .find("a, button, input, select, textarea")
              .filter(":visible");

            var firstFilterFocusable = $filterFocusable.first()[0];
            var lastFilterFocusable = $filterFocusable.last()[0];

            var activeFilterElement = document.activeElement;
            var isTabFilterForward = !e.shiftKey;

            if (
              activeFilterElement === lastFilterFocusable &&
              isTabFilterForward
            ) {
              e.preventDefault();
              firstFilterFocusable.focus();
            } else if (
              activeFilterElement === firstFilterFocusable &&
              !isTabFilterForward
            ) {
              e.preventDefault();
              lastFilterFocusable.focus();
            }
          }
        });
      }
    });

    // Close Button
    $("#znt-filter-btn-close_01").click(function () {
      var expanded = $("#znt-filter-btn_01").attr("aria-expanded");
      if (expanded === "true") {
        $("#znt-filter-btn_01").attr("aria-expanded", "false");
        setTimeout(function () {
          $("#znt-filter-btn_01").focus();
        }, 200);
      }
    });
  }
});

// Footer Accordions refactor
$(document).ready(function () {
  if ($(".znt-footer-disclusure-wrapper").length) {
    $(".znt-footer-disclusure-btn").click(function () {
      var expandedAcco = $(this).attr("aria-expanded");
      if (expandedAcco === "true") {
        $(this).attr("aria-expanded", "false");
      } else {
        $(this).attr("aria-expanded", "true");
      }
    });
  }
});

// Product Accordion refactor
$(document).ready(function () {
  if ($(".znt-disclosure-wrapper").length) {
    $(".znt-disclosure-btn").click(function () {
      var expandedAcco = $(this).attr("aria-expanded");
      if (expandedAcco === "true") {
        $(this).attr("aria-expanded", "false");
      } else {
        $(this).attr("aria-expanded", "true");
      }
    });
  }
});



// Zenyth's Disclosure component
// Global button toggle
$(document).ready(function () {
  if ($(".znt-disclosure_button").length) {
    // Base aria-expanded toggler
    $(".znt-disclosure_button").each(function () {
      $(this)
        .off("click")
        .click(function () {
          const expanded = $(this).attr("aria-expanded") === "true";
          if (expanded) {
            $(this).attr("aria-expanded", false);
          } else {
            $(this).attr("aria-expanded", true);
            // Sends focus to the first item within the .znt-disclosure_panel, for disclosure search components
            const $togglePanel = $(this).siblings(
              ".znt-disclosure_panel[znt-disclosure_focus-first]"
            );
            // Delay focus by second to give the SR time to announce the state
            setTimeout(function () {
              $togglePanel
                .find(
                  "a[href], button, textarea, input, select, [tabindex='0']"
                )
                .first()
                .focus();
            }, 100);
          }
        });
    });
    // END OF - Base aria-expanded toggler

    // ESC Key implementation
    // Closes the panel pressing ESC key
    $(document).keyup(function (e) {
      if (e.key === "Escape") {
        $(".znt-disclosure_button").each(function () {
          $(this)
            .siblings(".znt-disclosure_panel")
            .find(":focus")
            .closest(".znt-disclosure_panel")
            .siblings(".znt-disclosure_button")
            .focus();
          $(this).attr("aria-expanded", false);
        });
      }
    });
    // END OF - ESC Key implementation

    // Closes with focus out handler
    $("[znt-disclosure-focusout]").each(function () {
      $(this).on("focusout", function (e) {
        if (!$(this).has(e.relatedTarget).length) {
          const $toggleButton = $(this).find(".znt-disclosure_button");
          $toggleButton.attr("aria-expanded", false);
        }
      });
    });
    // END OF - Closes with focus out handler

    // Open the panel on hover
    if ($("[znt-disclosure-hoverable]").length) {
      $("[znt-disclosure-hoverable]").hover(
        function () {
          $(this).find("button").attr("aria-expanded", "true");
        },
        function () {
          $(this).find("button").attr("aria-expanded", "false");
        }
      );
    }
    // END OF - Open the panel on hover

    // Dynamic ID
    $(".znt-disclosure_button").each(function () {
      // Generate a unique ID using a timestamp and a random number to ensure uniqueness
      const uniqueId =
        "znt-disclosure_" +
        Date.now() +
        "_" +
        Math.floor(Math.random() * 1000000);

      // Setting aria-expanded to false initially
      $(this).attr("aria-expanded", "false");

      // Find the closest common ancestor element that contains both the button and the panel
      // Then find the specific panel within that ancestor
      const $closestCommonAncestor = $(this).closest(
        ":has(.znt-disclosure_panel)"
      );
      const $togglePanel = $closestCommonAncestor.find(".znt-disclosure_panel");

      // Check if a toggle panel was found
      if ($togglePanel.length) {
        // Assign the unique ID to the panel
        $togglePanel.attr("id", uniqueId);

        // Set the aria-controls attribute of the button to match the generated unique ID
        $(this).attr("aria-controls", uniqueId);
      }
    });
    // Dynamic ID

    // aria-expanded observer
    // Keeps only one panel opened when there is a hoverable with a non-hoverable button within the same <ul>

    // Check if there's any [znt-disclosure-hoverable] within a <ul>
    $("ul").each(function () {
      if ($(this).find("[znt-disclosure-hoverable]").length > 0) {
        // Target each <ul> that contains [znt-disclosure-hoverable]
        const observerZntDisclosure = new MutationObserver(function (
          mutations
        ) {
          mutations.forEach(function (mutation) {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "aria-expanded"
            ) {
              const $target = $(mutation.target);
              if ($target.attr("aria-expanded") === "true") {
                // Set aria-expanded="false" for other znt-disclosure_button within the same <ul>
                $target
                  .closest("ul")
                  .find('.znt-disclosure_button[aria-expanded="true"]')
                  .not($target)
                  .attr("aria-expanded", "false");
              }
            }
          });
        });

        // Observer configuration: watch for attributes changes in descendants
        const configZntDisclosure = {
          attributes: true,
          subtree: true,
          attributeFilter: ["aria-expanded"],
        };

        // Start observing the current <ul>
        observerZntDisclosure.observe(this, configZntDisclosure);
      }
    });
    // END OF - aria-expanded observer
  }
});


// Mega Menu fixes
// Zenyth Custom Main Navigation
// Replacing Details Summary
$(document).ready(function () {
  if ($(".znt-menu-item").length) {
    $(".znt-menu-item-btn").click(function () {
      var expanded = $(this).attr("aria-expanded");
      if (expanded === "true") {
        $(this).attr("aria-expanded", "false");
      } else {
        $(".znt-menu-item-btn").attr("aria-expanded", "false");
        $(this).attr("aria-expanded", "true");
      }
    });

    $(document).keyup(function (e) {
      if (e.key === "Escape") {
        $(".znt-menu-item-btn").attr("aria-expanded", "false");
      }
    });
  }
});

// Opens on hover
$(document).ready(function () {
  if ($(".znt-menu-item").length > 0) {
    $(".znt-menu-item").hover(
      function () {
        $(this).find(".znt-menu-item-btn").attr("aria-expanded", "true");
      },
      function () {
        $(this).find(".znt-menu-item-btn").attr("aria-expanded", "false");
      }
    );
  }
});


// Mega menu position when scrolling
$(document).ready(function () {
  var adjustMenu = function () {
    $(".znt-menu-item").each(function () {
      var menuItem = $(this);
      var menuPanel = menuItem.find(".znt-menu-panel.mega-menu__content");

      if (menuPanel.length) {
        var menuItemHeight = menuItem.outerHeight();
        var menuItemOffsetTop = menuItem.offset().top;
        var scrollPosition = $(window).scrollTop();

        var topValue = menuItemOffsetTop + menuItemHeight - scrollPosition + 18;
        menuPanel.css({
          position: "fixed",
          top: topValue + "px",
        });
      }
    });
  };

  var startAdjustMenuInterval = function () {
    var interval = setInterval(adjustMenu, 250);
    setTimeout(function () {
      clearInterval(interval);
    }, 10000); // Stop after 10 seconds
  };

  adjustMenu();

  $(window).on("scroll resize", adjustMenu);

  startAdjustMenuInterval();
});

$(document).ready(function () {
  if ($(".znt-mobile-menu-wrapper").length) {
    $(".znt-mobile-menu-btn").click(function () {
      var expanded = $(this).attr("aria-expanded");
      if (expanded === "true") {
        $(this).attr("aria-expanded", "false");
      } else {
        $(".znt-mobile-menu-btn").attr("aria-expanded", "false");
        $(this).attr("aria-expanded", "true");

        var $mobileMenu = $(".znt-mobile-menu-wrapper");

        $mobileMenu.on("keydown", function (e) {
          if (e.keyCode === 9) {
            // Tab key
            var $focusElements = $mobileMenu
              .find("a, button, input, select, textarea")
              .filter(":visible");
            var firstElement = $focusElements.first()[0];
            var lastElement = $focusElements.last()[0];
            var currentElement = document.activeElement;
            var tabForward = !e.shiftKey;

            if (currentElement === lastElement && tabForward) {
              e.preventDefault();
              firstElement.focus();
            } else if (currentElement === firstElement && !tabForward) {
              e.preventDefault();
              lastElement.focus();
            }
          }
        });
      }
    });

    $(document).keyup(function (e) {
      if (e.key === "Escape") {
        $(".znt-mobile-menu-btn").attr("aria-expanded", "false");
      }
    });
  }
});

$(document).ready(function () {
  // Handler for opening submenus and managing focus
  $(".znt-submenu-btn").click(function () {
    var $this = $(this);
    var $wrapper = $this.closest(".znt-submenu-wrapper");
    var expanded = $this.attr("aria-expanded") === "true";
    $this.attr("aria-expanded", !expanded);

    if (!expanded) {
      setTimeout(function () {
        var $submenuPanel = $this.next(".znt-submenu-panel");
        $submenuPanel.find(".znt-submenu-btn-close").focus();

        // Traps focus within the submenu
        $submenuPanel.on("keydown", function (e) {
          if (e.keyCode === 9) {
            // Tab key
            var $focusable = $submenuPanel
              .find("a, button, input, select, textarea")
              .filter(":visible");
            var firstFocusable = $focusable.first()[0];
            var lastFocusable = $focusable.last()[0];
            var activeElement = document.activeElement;
            var isTabForward = !e.shiftKey;

            if (activeElement === lastFocusable && isTabForward) {
              e.preventDefault();
              firstFocusable.focus();
            } else if (activeElement === firstFocusable && !isTabForward) {
              e.preventDefault();
              lastFocusable.focus();
            }
          }
        });
      }, 1000);
    }
  });

  // Handler for closing submenus and returning focus to the menu button
  $(".znt-submenu-btn-close").click(function () {
    var $closeButton = $(this);
    var $submenuPanel = $closeButton.closest(".znt-submenu-panel");
    var $submenuButton = $submenuPanel.prev(".znt-submenu-btn");

    $submenuButton.attr("aria-expanded", "false");

    setTimeout(function () {
      $submenuButton.focus();
    }, 0);
  });

  // Handler to close all submenus on pressing the escape key
  $(document).keyup(function (e) {
    if (e.key === "Escape") {
      $(".znt-submenu-btn").each(function () {
        var $this = $(this);
        var $wrapper = $this.closest(".znt-submenu-wrapper");
        if ($this.attr("aria-expanded") === "true") {
          $this.attr("aria-expanded", "false");
        }
      });
    }
  });



   setTimeout(function () {
  const toggleButtons = document.querySelectorAll(".znt-toggle-button");
  const closeButtons = document.querySelectorAll(".znt-toggle-close");

  function toggleAriaExpanded(button) {
    const isExpanded = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", isExpanded ? "false" : "true");
  }

  toggleButtons.forEach((button) => {
    button.addEventListener("click", () => toggleAriaExpanded(button));
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      toggleButtons.forEach((toggle) => toggle.setAttribute("aria-expanded", "false"));
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" || event.key === "Esc") {
      toggleButtons.forEach((button) => button.setAttribute("aria-expanded", "false"));
    }
  });
     }, 500);
});




console.log('test000000003');



// // Cookie Banner Dialog Focus Trap
// // Commented after no Cookies banner identified 
// // "Cookie banner - Not required for regions you're selling in"
// document.addEventListener("DOMContentLoaded", function () {
//   // Add a delay to ensure the dialog has loaded
//   setTimeout(function () {
//     const bannerDialog = document.getElementById("shopify-pc__banner");

//     if (bannerDialog) {
//       const managePrefsButton = document.getElementById(
//         "shopify-pc__banner__btn-manage-prefs"
//       );
//       const acceptButton = document.getElementById(
//         "shopify-pc__banner__btn-accept"
//       );
//       const declineButton = document.getElementById(
//         "shopify-pc__banner__btn-decline"
//       );
//       const body = document.body;

//       const focusableElements = bannerDialog.querySelectorAll(
//         'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
//       );
//       const firstFocusableElement = focusableElements[0];
//       const lastFocusableElement =
//         focusableElements[focusableElements.length - 1];

//       function trapFocus(e) {
//         const isTabPressed = e.key === "Tab" || e.keyCode === 9;

//         if (!isTabPressed) {
//           return;
//         }

//         if (e.shiftKey) {
//           if (document.activeElement === firstFocusableElement) {
//             e.preventDefault();
//             lastFocusableElement.focus();
//           }
//         } else {
//           if (document.activeElement === lastFocusableElement) {
//             e.preventDefault();
//             firstFocusableElement.focus();
//           }
//         }
//       }

//       function handleEscape(e) {
//         if (e.key === "Escape" || e.keyCode === 27) {
//           closeDialog();
//         }
//       }

//       function closeDialog() {
//         bannerDialog.style.display = "none";
//         document.removeEventListener("keydown", trapFocus);
//         document.removeEventListener("keydown", handleEscape);
//         body.focus();
//       }

//       function openManagePrefsDialog() {
//         document.removeEventListener("keydown", trapFocus);
//         document.removeEventListener("keydown", handleEscape);
//       }

//       managePrefsButton.addEventListener("click", openManagePrefsDialog);
//       acceptButton.addEventListener("click", closeDialog);
//       declineButton.addEventListener("click", closeDialog);
//       document.addEventListener("keydown", handleEscape);
//       bannerDialog.addEventListener("keydown", trapFocus);

//       // Ensure the dialog is visible and set initial focus if needed
//       bannerDialog.style.display = "block";
//       firstFocusableElement.focus();
//     }
//   }, 3000); // 3-second timeout
// });
// END OF - Cookie Banner Dialog Focus Trap
